<span> {{ value }}</span>

<span *ngIf="showWorstOffenderBadge && hasWorstOffenderBadge" [dz-tooltip]="worstOffenderTooltipContent" [dz-tooltip-hover]="true" [dz-tooltip-position]="'top'">
	<span class="tooltip-badge" dzBadge [dzBadgeOverlap]="true" dzBadgePosition="right-start" dzBadgeColor="red" dzBadgeSize="small"></span>
</span>

<ng-template #worstOffenderTooltipContent>
	<span dcrHTMLKey="WORST_TAX_OFFENDER_TABLE_TOOLTIP">Worst Tax Offender</span>
</ng-template>
